import { render, staticRenderFns } from "./SintomasEvacuaciones.vue?vue&type=template&id=70853aaa"
import script from "./SintomasEvacuaciones.vue?vue&type=script&lang=js"
export * from "./SintomasEvacuaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports